import React, { useState } from 'react';
import { db } from '../../firebase';
import { doc, updateDoc } from 'firebase/firestore';
import { useAuth } from 'hooks/useAuth';

const NameVerification = () => {
  const { user, updateUserContext, setStep, logOut } = useAuth();
  const [name, setName] = useState('');
  const [selectedClass, setSelectedClass] = useState('A'); // State for selected class
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerification = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('名前を入力してください。');
      return;
    }
    if (!selectedClass) {
        setError('クラスを選択してください。');
        return;
    }
    setLoading(true);
    setError('');

    try {
      const userDocRef = doc(db, 'users', user.uid);

      // Update with name and class
      await updateDoc(userDocRef, {
        name: name.trim(),
        class: selectedClass,
      });
      
      // Update user context to reflect the change immediately
      updateUserContext({ name: name.trim(), class: selectedClass });

      // The onSnapshot listener in useAuth will handle the step change
    } catch (err) {
      console.error("Error during name verification:", err);
      setError('エラーが発生しました。もう一度お試しください。');
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = async () => {
    await logOut();
    setStep(1);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-200">
      <div className="w-full max-w-md p-8 space-y-6 bg-white dark:bg-gray-800 rounded-lg shadow-md border border-transparent dark:border-gray-700">
        <h2 className="text-2xl font-bold text-center text-gray-800 dark:text-white">初回プロフィール設定</h2>
        <p className="text-center text-gray-600 dark:text-gray-400">
          学習を始める前に、表示名とクラスを登録しましょう。
        </p>
        <form onSubmit={handleVerification} className="space-y-6">
          <div>
            <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
              表示名
            </label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500"
              placeholder="好きな名前を入力"
              required
            />
             <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">ここで設定した名前は、後からいつでも自由に変更できます。</p>
          </div>
          
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                クラス
            </label>
            <div className="flex gap-2">
                {['A', 'B'].map(cls => (
                    <button
                        type="button"
                        key={cls}
                        onClick={() => setSelectedClass(cls)}
                        className={`flex-1 py-2 px-3 rounded-md border text-sm font-medium transition-colors ${
                            selectedClass === cls 
                            ? 'bg-indigo-600 text-white border-indigo-600' 
                            : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600'
                        }`}
                    >
                        {cls}組
                    </button>
                ))}
            </div>
            <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">クラスは後から変更できませんのでご注意ください。</p>
          </div>

          {error && <p className="text-sm text-red-500 text-center">{error}</p>}
          <div>
            <button
              type="submit"
              disabled={loading}
              className="w-full px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
            >
              {loading ? '確認中...' : '登録して開始'}
            </button>
            <button
              type="button"
              onClick={handleBackToLogin}
              className="w-full mt-3 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              ログイン方法を変更する
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NameVerification;
